import React from 'react'
import {BsTwitter, BsInstagram} from 'react-icons/bs'
import {FaFacebookF, FaWhatsapp, FaLinkedinIn} from 'react-icons/fa'

const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
        <a
            href="https://twitter.com/scooljinstitute"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow us on Twitter"
          >
            <BsTwitter />
         </a>
        </div>
        <div>
        <a
            href="https://web.facebook.com/scooljinstitute/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow us on Facebook"
          >
            <FaFacebookF />
          </a>
        </div>
        <div>
        <a
            href="https://www.instagram.com/scooljinstitute"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow us on Instagram"
          >
            <BsInstagram />
          </a>
        </div>
        <div>
        <a
            href="https://www.linkedin.com/company/scooljinstitute"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Connect with us on LinkedIn"
          >
            <FaLinkedinIn />
          </a>
        </div>
         <div>
         <a
            href="https://wa.me/2347034756746"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contact us on WhatsApp"
          >
              <FaWhatsapp  />
            </a>
        </div>
    </div>
  )
}

export default SocialMedia